import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import signinActions from 'src/store/modules/signin/actions';
import MobileMenu from './MobileMenu';
import { accountsSel, userActions, userDataSel } from 'src/store/modules/user';
import { signInActions, activeAccountSel } from 'src/store/modules/signin';

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    isLoggedIn: state.signin.success,
    userData: userDataSel(state),
    accountID: activeAccountSel(state),
    showSwitchAccounts: accountsSel(state)
      ? accountsSel(state).length > 1
      : false
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  signout: () => dispatch(signinActions.signout()),
  getAccounts: () => dispatch(userActions.getUserAccounts()),
  getUserData: () => dispatch(userActions.getUserDetails())
});

export const pureComponent = MobileMenu;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(MobileMenu));

interface IDispatchFromProps {
  signout(): void;
  getAccounts(): void;
  getUserData(): void;
}
